import { CommonModule, TitleCasePipe, UpperCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { DateModule, UtcDatePipe } from '@epicuro-next/ataraxia/date';
import { EmptyPlaceholderModule } from '@epicuro-next/ataraxia/empty-placeholder';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { InputDateRangeModule } from '@epicuro-next/ataraxia/input-date-range';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { MultiRangeSliderModule } from '@epicuro-next/ataraxia/multi-range-slider';
import { RadioGroupModule } from '@epicuro-next/ataraxia/radio-group';
import { SegmentButtonsComponent } from '@epicuro-next/ataraxia/segment-buttons';
import { SkeletonBasicModule } from '@epicuro-next/ataraxia/skeleton-basic';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { FiltersListModule } from '@epicuro-next/features/filters-list';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { PBasketStateModule } from '@epicuro-next/state/p-basket-state';

import { FiltersLoadErrorComponent } from './components/load-error/filters-load-error.component';
import { FiltersLoadSkeletonComponent } from './components/load-skeleton/load-skeleton.component';
import { ProductsFilterColorComponent } from './components/products-filter-color/products-filter-color.component';
import { ProductsFilterDateRangeComponent } from './components/products-filter-date-range/products-filter-date-range.component';
import { ProductsFilterRangeComponent } from './components/products-filter-range/products-filter-range.component';
import { SearchFiltersContainerComponent } from './containers/search-filters-container/search-filters-container.component';
import { SearchFiltersComponent } from './containers/search-filters/search-filters.component';
import { FilterDisplayNamePipe } from './pipes/filter-display-name.pipe';
import { FilterValueDisplayNamePipe } from './pipes/filter-value-display-name.pipe';

@NgModule({
  imports: [
    CommonModule,
    FiltersListModule,
    PBasketStateModule,
    ModalModule,
    IconsModule,
    TooltipDirective,
    ConfigurationModule,
    AccordionModule,
    EmptyPlaceholderModule,
    SkeletonBasicModule,
    MultiRangeSliderModule,
    ReactiveFormsModule,
    RadioGroupModule,
    DateModule,
    InputDateRangeModule,
    FilterDisplayNamePipe,
    SegmentButtonsComponent,
  ],
  declarations: [
    SearchFiltersComponent,
    ProductsFilterColorComponent,
    FiltersLoadErrorComponent,
    FiltersLoadSkeletonComponent,
    FilterValueDisplayNamePipe,
    ProductsFilterRangeComponent,
    ProductsFilterDateRangeComponent,
    SearchFiltersContainerComponent,
  ],
  providers: [UpperCasePipe, TitleCasePipe, UtcDatePipe],
  exports: [
    SearchFiltersComponent,
    ProductsFilterRangeComponent,
    SearchFiltersContainerComponent,
    FilterValueDisplayNamePipe,
  ],
})
export class ProductsFiltersModule {}
